import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

// Store tiles shown inside BuyBookModal.
const StoreLinks = ({ stores }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
    {stores.map((store) => (
      <a
        key={store.key}
        href={store.url}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative bg-white/[0.06] hover:bg-white/[0.12] border border-white/10 hover:border-[#2aa9a0]/60 rounded-xl px-3 py-3.5 flex items-center gap-2.5 transition-all duration-200"
      >
        <span className="w-9 h-9 rounded-lg bg-white flex items-center justify-center p-1.5 flex-shrink-0">
          <img
            src={store.logo}
            alt=""
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </span>
        <span className="text-white text-[12.5px] leading-tight font-medium min-w-0 flex-1">
          {store.name}
        </span>
        <FontAwesomeIcon
          icon={faArrowUpRightFromSquare}
          className="text-[#2aa9a0] text-[10px] opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
        />
      </a>
    ))}
  </div>
);

export default StoreLinks;
